export const languages = [
  { code: 'ko', name: '한국어', tag: 'ko-KR' },
  { code: 'en', name: 'English', tag: 'en' },
  { code: 'ja', name: '日本語', tag: 'ja-JP' },
  { code: 'zh', name: '简体中文', tag: 'zh-Hans' },
  { code: 'zh-Hant', name: '繁體中文', tag: 'zh-Hant' },
  { code: 'hi', name: 'हिन्दी', tag: 'hi-IN' },
  { code: 'es', name: 'Español', tag: 'es' },
  { code: 'id', name: 'Bahasa Indonesia', tag: 'id' },
  { code: 'pt', name: 'Português (Brasil)', tag: 'pt-BR' },
];

export function matchLocale(value) {
  const parts = String(value || '').trim().replaceAll('_', '-').toLowerCase().split('-');
  if (parts[0] === 'zh') {
    if (parts.includes('hant') || (!parts.includes('hans') && parts.some(p => ['tw', 'hk', 'mo'].includes(p)))) return 'zh-Hant';
    return 'zh';
  }
  return languages.find(l => l.code === parts[0])?.code;
}

export const normalizeLocale = value => matchLocale(value) || 'en';
export const publicPath = (locale, page = '') => `/${normalizeLocale(locale)}/${page ? `${page}/` : ''}`;

// Explicit URL > saved preference > device languages, just like the app.
export function detectLocale({ pathname = '', search = '', saved, browserLanguages = [] } = {}) {
  return matchLocale(new URLSearchParams(search).get('lang'))
    || matchLocale(pathname.split('/')[1])
    || matchLocale(saved)
    || browserLanguages.map(matchLocale).find(Boolean)
    || 'en';
}

export function browserLocale(saved) {
  if (typeof window === 'undefined') return normalizeLocale(saved);
  return detectLocale({ pathname: window.location.pathname, search: window.location.search,
    saved, browserLanguages: navigator.languages || [navigator.language] });
}
